module.exports = __webpack_public_path__ + "media/images/delivary-icon-9a84f050e6241fa638903f878b22afa4.svg";